import { Component, OnInit, Input, AfterViewInit, ViewChild, ElementRef, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { IContentElement, QuestionState, ScoringTypes, getElementWeight } from '../models';
import { AuthService } from '../../api/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { QuestionPubSub } from '../question-runner/pubsub/question-pubsub';
import { IEntryStateCamera } from './model';
import { LangService } from '../../core/lang.service';


export const getShowCameraText = () => {
  return 'Show Camera';
}

export const getTakePictureText = () => {
  return 'Take Picture';
}

const SCORING_TYPE = ScoringTypes.MANUAL;
@Component({
  selector: 'element-render-camera',
  templateUrl: './element-render-camera.component.html',
  styleUrls: ['./element-render-camera.component.scss']
})
export class ElementRenderCameraComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

  @ViewChild('video') videoEl:ElementRef;
  @ViewChild('canvas') canvasEl:ElementRef;

  @Input() element:IContentElement;
  @Input() isLocked:boolean;
  @Input() isShowSolution:boolean;
  @Input() questionState:QuestionState;
  @Input() changeCounter:number;
  @Input() questionPubSub?: QuestionPubSub;

  constructor(
    private auth: AuthService,
    private sanitizer: DomSanitizer,
    private lang: LangService
  ) { }

  isVideoOpen:boolean;
  isSnapTaken:boolean;
  statusMessage = '';
  lastTrackedQuestionState;

  ngOnInit() {
    this.ensureState();
  }

  getShowCameraText() {
    return getShowCameraText();
  }

  getTakePictureText() {
    return getTakePictureText();
  }

  ngOnDestroy(){
    this.closeCamera();
  }

  ngAfterViewInit(){

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isLocked && this.isLocked) {
      this.closeCamera();
    }
  }

  private closeCamera() {
    const video:HTMLVideoElement = this.videoEl && this.videoEl.nativeElement;
    const stream = video && video.srcObject as MediaStream;
    if (stream && stream.getTracks) {
      stream.getTracks().forEach(track => track.stop());
      video.srcObject = null;
    }
    this.isVideoOpen = false;
  }

  ensureState(){
    if (this.questionState){
      const entryId = this.element.entryId;
      if (!this.questionState[entryId]){
        let entryState:IEntryStateCamera = {
          type: 'camera',
          isCorrect: false,
          isStarted: false,
          isFilled: false,
          isResponded: false,
          score: 0,
          weight: getElementWeight(this.element),
          scoring_type: SCORING_TYPE, 
        }
        this.questionState[entryId] = entryState;
      }
      else{
        if(this.questionState[entryId].url){          
          this.isSnapTaken = true;
          this.isVideoOpen = false;   
          this.questionState[entryId].isResponded = true;
          let image = new Image();
          image.onload=()=>{
            let context = this.canvasEl.nativeElement.getContext('2d');
            context.drawImage(image,0, 0, 640, 480);
          };
          image.src= this.questionState[entryId].url;
        }
      }
    }
  }

  photoStart(){
    if (this.isLocked) return;
    this.isVideoOpen = true;
    this.isSnapTaken = false;
    this.statusMessage = this.lang.tra('sr_camera_requesting');
    let video = this.videoEl.nativeElement;
    const component = this;
    if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then(function(stream) {
          if (component.isLocked) {
            stream.getTracks().forEach(track => track.stop());
            return;
          }
          video.srcObject = stream;
          video.play();
          component.statusMessage = component.lang.tra('sr_camera_ready');
        }, function() {
          if (component.isLocked) return;
          component.statusMessage = component.lang.tra('sr_camera_unavailable');
        });
    }
    else{
      this.statusMessage = this.lang.tra('sr_camera_unavailable');
    }
  }

  photoSnap(){
    if (this.isLocked) return;
    var video = this.videoEl.nativeElement;
    var context = this.canvasEl.nativeElement.getContext('2d');
    context.drawImage(video, 0, 0, 640, 480);
    this.isSnapTaken = true;
    this.isVideoOpen = false;
    this.questionState[this.element.entryId].isResponded = true;   
    this.statusMessage = this.lang.tra('sr_camera_uploading');
    
    let img = this.canvasEl.nativeElement.toDataURL("image/png");
    let binary = atob(img.split(',')[1]);
    let array = []
    let i = 0
    while (i < binary.length){
      array.push(binary.charCodeAt(i))
      i++
    }
    let img_blob = new Blob([ new Uint8Array(array) ], {type: 'image/png'})

    this.auth
    .uploadFile(img_blob, 'camera_capture_' + Date.now()+'.png', 'authoring', true)
    .then(res => {
      if (this.isLocked) return;
      if (this.questionState){
        const entryState:IEntryStateCamera = this.questionState[this.element.entryId];
        if (entryState){
          entryState.url = res.url;
          entryState.isFilled = true;
          entryState.isStarted = true;
          entryState.isResponded = true;
          entryState.isCorrect = true;
          entryState.score = getElementWeight(this.element);
        }
      }
      this.statusMessage = this.lang.tra('sr_camera_saved');
    })
    .catch(() => {
      if (this.isLocked) return;
      this.statusMessage = this.lang.tra('sr_camera_upload_failed');
    });
  }

  getText(slug:string){
    return this.lang.tra(slug);
  }

}
